import { toUpper, split, join, pipe, map, filter, head, complement, isEmpty } from 'ramda';

export const capitalize = (str) => str.replace(/^./, toUpper);

export const capitalizeAll = pipe(split(' '), map(capitalize), join(' '));

// taken almost entirely from obrv2
export const shortenGroupName = (value) => {
    const words = filter(complement(isEmpty), split(' ', value));
    const firstLetters = map(head, words);

    if (words.length > 2) {
        return firstLetters.slice(0, 3).join('');
    }
    if (words.length === 2 && words[1].length > 1) {
        return firstLetters[0] + words[1].slice(0, 2);
    }
    if (words.length && words[0].length > 2) {
        return words[0].slice(0, 3);
    }
    return '';
};

export const addEndSlashForUrl = (url) => {
    if (url.includes('?')) {
        return url;
    }
    if (!url.endsWith('/')) {
        return `${url}/`;
    }
    return url;
};

export const findTextInString = (string, text) => string.toLowerCase().includes(text.toLowerCase());

export const replaceAccents = (str) => {
    if (!str) return str;

    return str
        .toLowerCase()
        .replace(/[áàãâäą]/gi, 'a')
        .replace(/[éèëêę]/gi, 'e')
        .replace(/[íìïî]/gi, 'i')
        .replace(/[óòöôõø]/gi, 'o')
        .replace(/[úùüû]/gi, 'u')
        .replace(/[çć]/gi, 'c')
        .replace(/[ñń]/gi, 'n')
        .replace(/[ł]/gi, 'l')
        .replace(/[żź]/gi, 'z');
};

export const truncateMiddle = (text, maxLength) => {
    if (text.length <= maxLength) return text;

    const half = Math.floor((maxLength - 3) / 2);
    return `${text.slice(0, half)}...${text.slice(-half)}`;
};
